import React from "react";

import Nav from "@/components/sections/Nav";
import ReviewForm from "@/components/sections/ReviewForm";
import Footer from "@/components/sections/Footer";
import CookieBanner from "@/components/CookieBanner";

export default function Reviews() {
    return (
        <div data-testid="reviews-page" className="bg-bg text-ink">
            <Nav />
            <main>
                <section className="border-b border-border bg-surface">
                    <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16 py-16 md:py-24">
                        <span className="overline">Customer feedback</span>
                        <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold tracking-tight mt-4 leading-[1.02] text-ink max-w-4xl">
                            Leave a ReachForge Leads review.
                        </h1>
                        <p className="mt-6 text-lg md:text-xl text-ink-soft max-w-2xl">
                            Tell us what the app helped you do, what worked
                            well, or what could be improved. Reviews are saved
                            privately first and only appear publicly after admin
                            approval.
                        </p>
                    </div>
                </section>
                <section className="border-b border-border bg-bg">
                    <div className="mx-auto max-w-[1440px] px-6 md:px-12 lg:px-16 py-16 md:py-20">
                        <ReviewForm />
                    </div>
                </section>
            </main>
            <Footer />
            <CookieBanner />
        </div>
    );
}
